import { render } from "./IntegrationPagination.vue?vue&type=template&id=72247557&scoped=true"
import script from "./IntegrationPagination.vue?vue&type=script&lang=ts"
export * from "./IntegrationPagination.vue?vue&type=script&lang=ts"

import "./IntegrationPagination.vue?vue&type=style&index=0&id=72247557&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-72247557"

export default script